import { useEffect, useState } from 'react'
import axios from 'axios'

export default function useSongsSearch(query, pageNumber, language, blockedSongs, blockedLangs) {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [songs, setSongs] = useState([])
  const [hasMore, setHasMore] = useState(false)

  useEffect(() => {
    setSongs([])
  }, [query, language, blockedSongs, blockedLangs])

  useEffect(() => {
    setLoading(true)
    setError(false)
    
    let cancel
    axios({
      method: 'GET',
      url: `https://starboxkod.com/api/songs/${query.toUpperCase()}/${pageNumber}/${language}/${JSON.stringify(blockedSongs)}/${JSON.stringify(blockedLangs)}/`,
/*       params: { q: query, page: pageNumber }, */
      cancelToken: new axios.CancelToken(c => cancel = c)
    }).then(res => {
      setSongs(prevSongs => {
        return [...new Set([...prevSongs, ...res.data])]
      })
      setHasMore(res.data.length > 0 )
      setLoading(false)
    }).catch(e => {
      if (axios.isCancel(e)) return
      setError(true)
    })
    return () => cancel()
  }, [query, pageNumber, language, blockedSongs, blockedLangs])
  return { loading, error, songs, hasMore}
}
